import type { Features, NavItem, ToolOverride } from "@atomic/app-shell";
import { Blocks, GlassWater, Sparkles, TrendingUp, Warehouse } from "lucide-react";

/** What LMNT tells the shell's rail: the live features, the Engine tiles and
 *  the tile overrides. One module so main.tsx and routeRegistry.test.ts build
 *  the same nav — the registry the assistant routes on is derived from it. */

/** Data, Reporting, Digital Twin and Nucleus are live. Tracker, Allocation and
 *  Linear stay off the rail (the shell's default for them) — LMNT reaches
 *  /trackers, /allocation-engine and /linear by direct navigation, through its
 *  own routes. */
export const FEATURES: Features = { masterdata: true, reporting: true, digitalTwin: true, nucleus: true };

/** The Replenishment page split three ways (LMN experiment): Supply is its
 *  Balance Walk alone; Sparkling and Drink Mix are its Production + Transfers
 *  scoped to one product class each, with independently locked plans.
 *  /replenishment itself stays routed — links and bookmarks keep working — it
 *  just has no tile. ADMIN/ROOT only, which needs no rule here: the shell
 *  hides the Engine group from a DATA_USER wholesale and admits one to Data
 *  and Reporting and nothing else. Materials is the Engine module still to
 *  come. */
export const NAV_EXTRAS: NavItem[] = [
  { href: "/demand", name: "Demand", icon: TrendingUp, group: "engine", aliases: ["demand reporting", "forecast"], description: "Demand reporting and sales-forecast views." },
  { href: "/supply", name: "Supply", icon: Warehouse, group: "engine", aliases: ["supply", "balance walk page"], description: "The Replenishment Balance Walk on its own page." },
  { href: "/sparkling", name: "Sparkling", icon: Sparkles, group: "engine", aliases: ["sparkling planning"], description: "Production + Transfers planning for the Sparkling class." },
  { href: "/drink-mix", name: "Drink Mix", icon: GlassWater, group: "engine", aliases: ["drink mix planning"], description: "Production + Transfers planning for the Drink Mix class." },
  { href: "/materials", name: "Materials", icon: Blocks, group: "engine", locked: true },
];

/** No Docs tile: the page stays routed, it is only off the rail. */
export const TOOL_OVERRIDES: ToolOverride[] = [{ href: "/docs", hidden: true }];
